import React, {PureComponent} from 'react';
import {connect} from 'react-redux';
import Carousel from '../carousel/Carousel';
import Card from './Card';
import LastCard from './LastCard';

import {SVGIcon} from '@homeaway/react-svg';
import {CAR__24} from '@homeaway/svg-defs';

import EdapViewTracker from '../../common/edap-view-tracker/EdapViewTracker';

import './Destinations.less';

const CAROUSEL_BREAKPOINTS = {
    1500: 4,
    640: 3,
    0: 2,
};

export function mapStateToProps({
    config: {
        site: {name: site},
    },
    modules: {
        destinations,
        jumbotron: {heading: simpleName},
    },
}) {
    return {
        destinations,
        simpleName,
        site,
    };
}

export class DestinationsComponent extends PureComponent {
    renderCards({lbsId, listings, moduleNumber, searchURL, text}) {
        const {site, tripboardComponent} = this.props;

        const cards = listings.map((listing, i) => {
            return (
                <Card
                    {...{
                        listing,
                        lbsId,
                        site,
                        moduleNumber,
                        cardNumber: i + 1,
                        tripboardComponent,
                    }}
                    key={listing.tripleId}
                />
            );
        });

        const image = listings[0].thumbnailUrl;
        cards.push(
            <LastCard
                {...{site, image, lbsId, text, searchURL, moduleNumber}}
                key={lbsId}
            />
        );

        return cards;
    }

    renderComponent() {
        const {destinations} = this.props;

        return (
            <div className="Destinations__wrapper">
                {destinations.map(
                    (
                        {
                            lbsId,
                            listings,
                            searchURL,
                            refinedListingCount,
                            translations: {
                                title,
                                search,
                                subheading,
                                drivingTimeSubheading,
                            },
                        },
                        i
                    ) => {
                        const newSubheading = drivingTimeSubheading ? (
                            <span className="driving-time">
                                <SVGIcon
                                    className="text-muted"
                                    markup={CAR__24}
                                />
                                {drivingTimeSubheading}
                            </span>
                        ) : (
                            subheading
                        );

                        return (
                            listings &&
                            listings.length >= 4 &&
                            !!refinedListingCount &&
                            !!title && (
                                <section
                                    className="Destinations section"
                                    key={`Destinations-${i}`}
                                >
                                    <Carousel
                                        {...{
                                            lbsId,
                                            title,
                                            subheading: newSubheading,
                                            actionHref: searchURL,
                                            actionText: search,
                                            carouselBreakpoints: CAROUSEL_BREAKPOINTS,
                                        }}
                                        key={`${title}${i}`}
                                        actionlocation={`destination-properties-module-${
                                            i + 1
                                        }`}
                                    >
                                        {this.renderCards({
                                            lbsId,
                                            listings,
                                            moduleNumber: i + 1,
                                            searchURL,
                                            text: search,
                                        })}
                                    </Carousel>
                                    <EdapViewTracker
                                        eventData={{
                                            actionlocation: `destination-properties-module-${
                                                i + 1
                                            }`,
                                        }}
                                    />
                                </section>
                            )
                        );
                    }
                )}
            </div>
        );
    }

    render() {
        const {destinations} = this.props;

        if (destinations.length < 3) {
            return null;
        }

        return this.renderComponent();
    }
}

export const Destinations = connect(mapStateToProps)(DestinationsComponent);

Destinations.displayName = 'Destinations';

export default Destinations;
